import * as invert from 'lodash/invert'
import { OnboardingStep } from 'interfaces/member'
import { ONBOARDING_PROPERTY_URL, ONBOARDING_REGISTER_URL, ONBOARDING_SUMMARY_URL, INTERNAL_ENTRY_URL } from 'tangle-shared'
import { ONBOARDING_PROPERTY, ONBOARDING_REGISTER, DASHBOARD_PAGE } from 'constants/pages'
import { PageType } from 'interfaces/pages'
import { IS_STATUS_APP_ANDROID } from 'helpers/userAgentHelpers'

export const ONBOARDING_STEP_URL_BY_NAME: Record<OnboardingStep, string> = {
  register: ONBOARDING_REGISTER_URL,
  property: ONBOARDING_PROPERTY_URL,
  finished: INTERNAL_ENTRY_URL,
}

export const ONBOARDING_STEP_BY_URL: Partial<Record<string, OnboardingStep>> = {
  [ONBOARDING_REGISTER_URL]: 'register',
  [ONBOARDING_PROPERTY_URL]: 'property',
  [ONBOARDING_SUMMARY_URL]: 'finished',
}

export const STEPS_COUNT_WITH_FORM = 2
export const ONBOARDING_STEP_NUMBERS: Record<OnboardingStep, number> = {
  register: 1,
  property: 2,
  // it's not step actually, do not consider it as a step
  finished: 3,
}

export const STEP_BY_REDIRECT_URL = invert(ONBOARDING_STEP_URL_BY_NAME) as Record<string, OnboardingStep>

export const ONBOARDING_STEP_ANCHOR_BY_NAME: Record<OnboardingStep, PageType> = {
  register: ONBOARDING_REGISTER,
  property: ONBOARDING_PROPERTY,
  finished: DASHBOARD_PAGE,
}

export const ENFORCE_POLICY_AGREEMENT = IS_STATUS_APP_ANDROID
